module.exports = __webpack_public_path__ + "web/img/grade3.7821708c.png";